import formModule from '../modules/forms/formModule.js'

export default {
	mounted () {
		formModule.init()
	},

	beforeDestroy () {
		formModule.destroy()
	}
}
